import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { ApprovalResource } from './ApprovalResource';
import { CycleValidationSnapshot } from './CycleValidationSnapshot';
import { CycleValidationApproval } from './CycleValidationApproval';
import { CycleValidationPostingFile } from './CycleValidationPostingFile';

export class SweepFileApprovalResource extends FBaseService implements ApprovalResource {
  public async getApproval(fiId: string, snapshotId: number): Promise<CycleValidationApproval> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/director/${fiId}/cycle-validation-approval/SWEEP/${snapshotId}`);

    const result: CycleValidationApproval = response.data.data;
    return result;
  }

  public async saveApproval(fiId: string, snapshot: CycleValidationSnapshot, approvalStatus: string, files: CycleValidationPostingFile[] | undefined): Promise<CycleValidationApproval> {
    const subFolders: string[] = [];

    if (files) {
      for (let idx = 0; idx < files.length; idx++) {
        const sweepFile = files[idx];
        const folderName = sweepFile.postingType;
        if (subFolders.indexOf(folderName) === -1) {
          subFolders.push(folderName);
        }
      }
    }

    const approval: CycleValidationApproval = {
      id: null,
      approvalDateTime: null,
      snapshotId: snapshot.id,
      approvalUserId: null,
      approvalState: approvalStatus,
      approvalType: 'SWEEP',
      subFolders,
    };
    const response: AxiosResponse = await this.apiClient.put(`/api/rcx/director/${fiId}/cycle-sweep-transfer/${snapshot.id}`, approval);

    const result: CycleValidationApproval = response.data.data;
    return result;
  }
}

export default SweepFileApprovalResource;
